var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAdvertising = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 4H3.8C2.2 4 1 5.2 1 6.8V15C1 16.5 2.2 17.7 3.8 17.7H6C6 17.7 6.0301 17.7 6.1 17.6L6.8 16.7L7.6 15.7L9.8 12.7C10.3 12 11.1 11.6 12 11.6C12.9 11.6 13.7 12 14.3 12.7L16.5 15.7L17.3 16.7L18 17.6L18.1 17.7H20.4C21.9 17.7 23.2 16.5 23.2 15V6.8C23 5.2 21.8 4 20.3 4Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 17.7001L14.7003 16.7001L13.9003 15.7001L12.6003 13.9001C12.5003 13.7001 12.2003 13.6001 11.9003 13.6001C11.6003 13.6001 11.4003 13.7001 11.2003 13.9001L10.0003 15.7001L9.20026 16.7001L8.40026 17.7001L7.60026 18.8001C7.40026 19.0001 7.40026 19.3001 7.50026 19.6001C7.70026 19.8001 8.00026 20.0001 8.30026 20.0001H15.6003C15.9003 20.0001 16.2003 19.8001 16.3003 19.6001C16.4003 19.3001 16.4003 19.1001 16.2003 18.8001L15.5003 17.7001Z",
    fill: "inherit"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdvertising, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/advertising.2e6436a0.svg";
export { ForwardRef as ReactComponent };